/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { router } from "@smakecloud/api-client-helper";
import { z } from "zod";
import { authedEndpoint } from "~/lib/api/builder";
import { sortingBinSchema } from "./sortingRackBins";

const productionProductionMethodSchema = z.object({
    id: z.number(),
    display_name: z.string().nullable(),
    production_method_handle: z.string(),
});

const sortingRackSchema = z.object({
    id: z.number(),
    name: z.string(),
    created_at: z.iso.datetime({ offset: true }),
    first_order_at: z.iso.datetime({ offset: true }).nullable(),
    production_id: z.number(),
    production_production_method: productionProductionMethodSchema,
    sorting_bins: z.array(sortingBinSchema).optional(),
    updated_at: z.iso.datetime({ offset: true }),
});

const listRacks = authedEndpoint.query(
    ({ production_method_id, search_params }) => ({
        searchParams: search_params,
        url: `production-methods/${production_method_id}/sorting-racks`,
    }),
    {
        input: z.object({
            production_method_id: z.number(),
            search_params: z
                .object({
                    cursor: z.string(),
                    filter: z
                        .object({
                            q: z.string(),
                        })
                        .partial(),
                    per_page: z.number(),
                })
                .partial()
                .optional(),
        }),
        output: z.object({
            data: z.array(sortingRackSchema),
            links: z.object({
                first: z.string().nullable(),
                last: z.string().nullable(),
                next: z.string().nullable(),
                prev: z.string().nullable(),
            }),
            meta: z.object({
                next_cursor: z.string().nullable(),
                path: z.string(),
                per_page: z.number(),
                prev_cursor: z.string().nullable(),
            }),
        }),
    },
);

const getRack = authedEndpoint.query(
    ({ production_method_id, sorting_rack_id }) => ({
        url: `production-methods/${production_method_id}/sorting-racks/${sorting_rack_id}`,
    }),
    {
        input: z.object({
            production_method_id: z.number(),
            sorting_rack_id: z.number(),
        }),
        output: sortingRackSchema,
    },
);

const createRack = authedEndpoint.mutation(
    ({ production_method_id, rack }) => ({
        json: rack,
        method: "POST",
        url: `production-methods/${production_method_id}/sorting-racks`,
    }),
    {
        input: z.object({
            production_method_id: z.number(),
            rack: z.object({
                name: z.string(),
                number_of_bins: z.number(),
            }),
        }),
        output: sortingRackSchema,
    },
);

const updateRack = authedEndpoint.mutation(
    ({ production_method_id, rack, sorting_rack_id }) => ({
        json: rack,
        method: "PATCH",
        url: `production-methods/${production_method_id}/sorting-racks/${sorting_rack_id}`,
    }),
    {
        input: z.object({
            production_method_id: z.number(),
            rack: sortingRackSchema,
            sorting_rack_id: z.number(),
        }),
        output: sortingRackSchema,
    },
);

const deleteRack = authedEndpoint.mutation(
    ({ production_method_id, sorting_rack_id }) => ({
        method: "DELETE",
        url: `production-methods/${production_method_id}/sorting-racks/${sorting_rack_id}`,
    }),
    {
        input: z.object({
            production_method_id: z.number(),
            sorting_rack_id: z.number(),
        }),
    },
);

import { sortingRackBins } from "./sortingRackBins";

export const sortingRacks = router({
    create: createRack,
    delete: deleteRack,
    get: getRack,
    list: listRacks,
    // Sub-Endpoints
    sortingRackBins,

    update: updateRack,
});
